import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom'

import StepSelectionTooltip from './StepSelectionTooltip'
import MediaQuery from 'react-responsive'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/pro-light-svg-icons/faCheck";

class StepSelectionButton extends Component {

    static propTypes = {
        stepLabel: PropTypes.string.isRequired,
        buttonLabel: PropTypes.string.isRequired,
        isAvailable: PropTypes.bool,
        isCompleted: PropTypes.bool,
        isActive: PropTypes.bool,
        isDisabled: PropTypes.bool,
        onStepSelectionClick: PropTypes.func,
        invalidStepJump: PropTypes.string,
        invalidStepJumpFirstTime: PropTypes.bool,
        onInvalidStepHover: PropTypes.func,
        onInvalidStepClick: PropTypes.func
    }

    static defaultProps = {
        invalidStepJump: "",
        invalidStepJumpFirstTime: true,
        onInvalidStepHover: (steps) => {
        },
        onInvalidStepClick: (steps) => {
        }
    }

    mouseOutTimeout = 0

    constructor(props) {
        super(props)
        this.state = {
            isButtonMouseOver: false,
            spanOffsetLeft: 0
        }
    }

    componentDidUpdate(prevProps) {
        if (this.buttonRef) {
            if (!this.props.isAvailable && !this.props.isActive) {
                this.buttonRef.setAttribute('inert', '');
            } else {
                this.buttonRef.removeAttribute('inert');
            }
        }
        if (prevProps.isActive !== this.props.isActive) {
            if (this.props.forwardedRef && this.props.forwardedRef.current) {
                this.props.forwardedRef.current.focus();
            }
        }
    }

    render() {

        let className = "step-selection__button";

        if (this.props.isAvailable) {
            className += " available";
        }

        if (this.props.isCompleted) {
            className += " completed";
        }

        if (this.props.isActive) {
            className += " active";
        }

        if (this.props.isDisabled) {
            className += " disabled";
        }

        return (

            <button
                type="button"
                ref={el => {
                    this.buttonRef = el;
                    // Apply the inert attribute manually
                    if (el && !this.props.isAvailable) {
                        el.setAttribute('inert', '');
                    }

                    // Assign to forwarded ref object
                    if (this.props.forwardedRef) {
                        this.props.forwardedRef.current = el;
                    }
                }}
                onMouseOver={(e) => {

                    if (this.props.isDisabled) {
                        return false
                    }

                    const dom = ReactDOM.findDOMNode(this)

                    this.setState({
                        isButtonMouseOver: true,
                        spanOffsetLeft: dom.getElementsByTagName('span')[0].offsetLeft
                    })
                    if (this.props.invalidStepJump !== "" && (this.props.isAvailable || this.props.isCompleted)) {
                        if (this.props.onInvalidStepHover) {
                            this.props.onInvalidStepHover()
                        }
                    }
                    if (this.mouseOutTimeout) {
                        clearTimeout(this.mouseOutTimeout)
                        this.mouseOutTimeout = 0
                    }
                }}
                onMouseOut={(e) => {

                    if (this.props.isDisabled) {
                        return false
                    }

                    this.mouseOutTimeout = setTimeout(() => {
                        this.setState({
                            isButtonMouseOver: false
                        })
                        this.mouseOutTimeout = 0
                    }, 0)
                }}
                onClick={(e) => {

                    if (this.props.isDisabled) {
                        return false
                    }

                    if (this.props.invalidStepJump !== "" && (this.props.isAvailable || this.props.isCompleted)) {
                        this.props.onInvalidStepClick()
                    }
                    if (!this.props.invalidStepJump) {
                        this.props.onStepSelectionClick()
                    }
                }}
                className={className + ((this.props.isAvailable && this.props.invalidStepJump) ? ' blocked' : '')}
            >
                <MediaQuery minWidth={760}>
                    {(isMatching) => {
                        return isMatching ? <span>{this.props.buttonLabel}</span> : <FontAwesomeIcon
                            icon={(this.props.isCompleted && !this.props.isActive) ? faCheck : this.props.buttonIcon}/>
                    }}
                </MediaQuery>
                {((this.state.isButtonMouseOver && this.props.isCompleted && !this.props.isActive) || (this.state.isButtonMouseOver && this.props.isAvailable && (this.props.invalidStepJump !== ""))) ?
                    <StepSelectionTooltip
                        style={{left: this.state.spanOffsetLeft}}
                        label={this.props.invalidStepJump !== "" ? `Bitte ${this.props.invalidStepJumpFirstTime ? "vervollständige" : "korrigiere"} deine Eingabe im Schritt ${this.props.invalidStepJump}.` : "Deine Eingaben bleiben erhalten."}
                    /> : null}

            </button>

        )

    }

}

export default StepSelectionButton



/** WEBPACK FOOTER **
 ** ./src/components/navigation/StepSelectionButton.js
 **/